import React from 'react';
import { Box, Typography } from '@mui/material';

function AnalyticsEmptyState({
  title,
  description,
  icon: Icon,
  minHeight = 160,
  sx,
}) {
  return (
    <Box
      data-testid="analytics-empty-state"
      sx={(theme) => ({
        minHeight,
        height: '100%',
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.75,
        px: 2,
        color: theme.palette.text.secondary,
        textAlign: 'center',
        ...sx,
      })}
    >
      {Icon && <Icon sx={{ fontSize: 22, opacity: 0.72 }} />}
      {title && (
        <Typography sx={{ fontSize: 13, fontWeight: 700, lineHeight: 1.2 }}>
          {title}
        </Typography>
      )}
      {description && (
        <Typography sx={{ fontSize: 11.5, lineHeight: 1.35, maxWidth: 420 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}

export default AnalyticsEmptyState;
